import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class BookStockService {
  //private apiUrl = '/bookstocks';
  private apiSpringUrl = '/spring/bookstocks';

  constructor(private http: HttpService) { }

  get(ownerId: number, targetDt: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${ownerId}/${targetDt}`;
    return this.http.get(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/book-stock/book-stock.service.ts